import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_COUNTRY'),
  ...asyncTypes('CREATE_COUNTRY')
};

export default TYPES;
